import { render, staticRenderFns } from "./SessionExpiredModalComponent.vue?vue&type=template&id=0cfba160"
import script from "./SessionExpiredModalComponent.vue?vue&type=script&lang=js"
export * from "./SessionExpiredModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports